import { render, staticRenderFns } from "./CategoryFiltering.vue?vue&type=template&id=04d2acbf&scoped=true&"
import script from "./CategoryFiltering.vue?vue&type=script&lang=js&"
export * from "./CategoryFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2acbf",
  null
  
)

export default component.exports